import { memo } from 'react';
import { format } from 'date-fns';

import Image from 'global/Image';
import { ForcedSellMapper } from 'global/Securities/types/store/order';

import {
  BannerWrapper,
  BannerTitleWrapper,
  BannerTitle,
  BannerDescription,
} from './component.styled';

interface DayTradeBannerProps {
  label: string;
  title?: string;
  timeOpen?: string;
  forcedSell?: boolean;
}

const formatTime = (time: string) => {
  const jsDate = new Date(time);

  const formattedDate = format(jsDate, 'dd MMM yyyy');
  const formattedHour = format(jsDate, 'HH:mm:ss');

  return `${formattedDate} pukul ${formattedHour}.`;
};

function DayTradeBanner({
  label,
  title = 'Day Trade Forced Sell',
  timeOpen,
  forcedSell = false,
}: DayTradeBannerProps) {
  const isForcedSell = !!ForcedSellMapper[label] || forcedSell;

  if (!isForcedSell) return null;

  return (
    <BannerWrapper>
      <BannerTitleWrapper>
        <Image
          src="/images/day-trade/info-danger.svg"
          alt="Info"
          height="18"
          width="18"
        />
        <BannerTitle>{title}</BannerTitle>
      </BannerTitleWrapper>

      <BannerDescription>
        Saham ini terkena Forced Sell sesuai ketentuan Day Trade pada{' '}
        {formatTime(timeOpen)}
      </BannerDescription>
    </BannerWrapper>
  );
}

export default memo(DayTradeBanner);
